import { toUrlParams } from '../base/url'
import { jump2TemplateMethod } from './base'
import { WX_PATH_PREFIX } from './mp-const'

export function getIPath(params = {}) {
  const queryString = toUrlParams(params)
  return `/native/coupon/list${queryString ? `?${queryString}` : ''}`
}

export default function jump2coupon(params = {}) {
  const queryString = toUrlParams(params)
  const iPath = getIPath(params)
  const mpDynamicPage = `/dynamic-page/index?needLogin=1${
    queryString ? `&${queryString}` : ''
  }&case=subpackage-secondary-discount-list`
  jump2TemplateMethod({
    useIphx: true,
    iPath,
    mpPathMap: {
      dianping_wxapp: `${WX_PATH_PREFIX.dianpingSub}${mpDynamicPage}`,
      group_wxapp: `${WX_PATH_PREFIX.meituan}${mpDynamicPage}`,
      hotel_wxapp: `${WX_PATH_PREFIX.hotelSub}${mpDynamicPage}|zhenguo`,
      phoenix_wxapp: `${WX_PATH_PREFIX.phxSub}/discount/list${queryString ? `?${queryString}` : ''}`,
    },
    rnPathConfig: {
      versions: { phx: '4.3.2' },
      mrn_entry: 'coupon',
      mrn_component: 'coupon',
      params,
    },
    dianping: `dianping://mycouponlist${queryString ? `?${queryString}` : ''}`,
    imeituan: `imeituan://www.meituan.com/voucher/list${queryString ? `?${queryString}` : ''}`,
  })
}
